import { FormBase } from 'core/components';

export default class ChangeDateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [{
                    name: 'date',
                    label: 'SCHEDULE.CALENDAR.EDIT.DATE_LABEL',
                    placeholder: 'SCHEDULE.CALENDAR.EDIT.DATE_PLACEHOLDER',
                    rules: 'required'
                },
            ],
        };
    }
}
